import React, {
  Component,
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import logoPsp from "../../assets/images/icon_home/logo-psp.svg";
import drop from "../../assets/images/icon_home/drop.svg";
import handLeft from "../../assets/images/icon_home/hand-left.svg";
import handRight from "../../assets/images/icon_home/hand-right.svg";
import notification from "../../assets/images/icon_home/notification.svg";
import arrowRight from "../../assets/images/icon_home/arrow-right.svg";
import wallet from "../../assets/images/icon_home/wallet.svg";
import all from "../../assets/images/icon_home/all.svg";
import close from "../../assets/images/icon_login/close-square.svg";
import card from "../../assets/images/icon_home/card.svg";
import addUser from "../../assets/images/icon_home/add-user.svg";
import transaction from "../../assets/images/icon_home/transaction.svg";
import mutation from "../../assets/images/icon_home/mutation.svg";
import attendance from "../../assets/images/icon_home/attendance.svg";
import saving from "../../assets/images/icon_home/saving.svg";
import timetable from "../../assets/images/icon_home/timetable.svg";
import invoice from "../../assets/images/icon_home/invoice.svg";
import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import info from "../../assets/images/icon_home/info.svg";
import banner from "../../assets/images/icon_stock/banner.png";
import donation from "../../assets/images/icon_home/donation.svg";
import schedule from "../../assets/images/icon_home/schedule.svg";
import calendar from "../../assets/images/icon_home/Calendar.svg";
import savings from "../../assets/images/icon_home/savings.svg";
import support from "../../assets/images/icon_home/support.svg";
import bsiBurekol from "../../assets/images/icon_home/bsi.svg";
import katalisMerah from "../../assets/images/icon_home/katalis-merah.svg";
import katalisHijau from "../../assets/images/icon_home/katalis-hijau.svg";

import users from "../../assets/images/icon_home/user.svg";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_balance from "../../core/service/api_balance";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Parallax, useParallax } from "react-scroll-parallax";
import { formatCurrency, handleUrl, showSvg } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setBalance } from "../../core/feature/user/balanceSlice";
import { removeToken, setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { removeBalance } from "../../core/feature/balance/balanceSlice";
import { getInfoNews } from "../../core/service/api_info";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { getBroadcastActive } from "../../core/service/api_notification";
import moment from "moment";
import { setLoading } from "../../core/feature/config/configSlice";
import { toast } from "react-toastify";
import CustomApp from "../../core/models/customApp";
import _ from "lodash";
import {
  removeCustomApp,
  setCustomApp,
} from "../../core/feature/company/customAppsSlice";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { openWhatsappAndroid } from "./../../config/AndroidBridge";
import { log } from "console";
import Company from "../../core/models/company";
import { removeLastService } from "../../core/feature/lastService/lastServiceSlice";
import PullToRefresh from "react-simple-pull-to-refresh";
import { setIconApp } from "../../core/feature/company/iconAppSlice";
import IconApp from "../../core/models/iconApp";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
import { isDarkColor } from "../../config/DarkColorChecker";
import { androidOpenUrlInBrowser } from "../../config/AndroidBridge";
import Routes from "../../Routes";
import { logoutIOS, openUrlInSafari } from "../../config/iosBridge";
import * as api_company from "../../core/service/api_company";
const HomeMobile = () => {
  const gaEventTracker = useAnalyticsEventTracker("Home");

  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  let company: any = JSON.parse(String(localStorage.getItem("company")));

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const token: String = useAppSelector((state) => state.token.token);
  const language: String = useAppSelector((state) => state.language.language);
  const iconApp: IconApp = useAppSelector((state) => state.iconApp.iconApp);
  const dataTags = JSON.parse(String(localStorage.getItem("tags")));

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [dataNews, setdataNews] = useState<any>([]);

  const [openDetailHistory, setOpenDetailHistory] = useState(false);

  const [menu, setMenu] = useState<any>([]);
  const [otherOpened, setOtherOpened] = useState(false);
  const [supportOpened, setSupportOpened] = useState(false);
  const [supportMessage, setSupportMessage] = useState("");
  const [dataBroadcast, setDataBroadcast] = useState<any>([]);
  const [broadcastOpened, setBroadcastOpened] = useState(false);
  const [skeletonIsActive, setSkeletonIsActive] = useState(true);
  const [accessFromApp, SetAccessFromApp] = useState(false);
  const auto = localStorage.getItem("auto_login");
  const skeleton_menu = [1, 2, 3, 4, 5, 6, 7, 8];
  const [handleSVG, sethandleSvg] = useState<any>({});
  const [headerImg, setHeaderImg] = useState<any>({});
  const [testa, setTesta] = useState<any>({});
  const [directUrl, setDirectUrl] = useState(false);
  const [totalActiveMenu, setTotalActiveMenu] = useState(0);
  const [appName, setAppName] = useState("");
  const [getToken, setTokens] = useState(localStorage.getItem("token_redux"));
  const [showPopup, setShowPopup] = useState(false);
  const [getCompanyInital, setCompanyInitial] = useState<any>("");
  const default_menu = {
    create_time: "2023-02-20T10:32:23",
    creator_id: "5ec1c4c8ea40dd3912ff2070",
    is_delete: false,
    app_display_name: "PSP Mobile",
    app_icon_url: "psp.svg",
    app_mobile_background_header_url: "header.svg",
    app_desktop_background_header_url: "header.svg",
    app_accent_color: "#0054E6",
    app_secondary_accent_color: "#0054E6",
    app_menu: [
      {
        id: "63f2e9c7c41173cbc057724a",
        menu_name: "Isi Ulang",
        menu_path: "/topup",
        menu_icon_url: "wallet.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc057724b",
        menu_name: "Tagihan",
        menu_path: "/invoice",
        menu_icon_url: "invoice.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc057724c",
        menu_name: "Mutasi",
        menu_path: "/mutation",
        menu_icon_url: "mutation.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc057724d",
        menu_name: "Transaksi",
        menu_path: "/transaction-history",
        menu_icon_url: "transaction.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc057724e",
        menu_name: "Absensi",
        menu_path: "/attendance",
        menu_icon_url: "attendance.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc057724f",
        menu_name: "Kartu Digital",
        menu_path: "/digital-card",
        menu_icon_url: "card.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc0577250",
        menu_name: "Akun",
        menu_path: "/account",
        menu_icon_url: "account.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc0577251",
        menu_name: "Donasi",
        menu_path: "/donation",
        menu_icon_url: "donation.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc0577252",
        menu_name: "Jadwal",
        menu_path: "/schedule",
        menu_icon_url: "schedule.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc0577253",
        menu_name: "Kalender Akademik",
        menu_path: "/calendar",
        menu_icon_url: "calendar.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
      {
        id: "63f2e9c7c41173cbc0577254",
        menu_name: "Bantuan",
        menu_path: "/etc",
        menu_icon_url: "support.svg",
        menu_is_show: true,
        menu_type: "PAGE",
      },
    ],
    company_id: "5ec1c4c7ea40dd3912ff206d",
    _id: "63f2e9c7c41173cbc0577255",
  };

  const env = Config.BaseUrlDev;
  const getBalance = useMemo(() => formatCurrency(balance), [balance]);
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  const isSafari = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      userAgent.includes("safari") &&
      !userAgent.includes("chrome") &&
      !userAgent.includes("android")
    );
  };

  const checkRouteExists = (path: string) => {
    return Routes.some((route: any) => "/" + route.path === path);
  };

  const handleMenuClick = (modifiedMenuPath: any, event: any, item: any) => {
    if (item.menu_type === "PAGE") {
      if (!checkRouteExists(item.menu_path)) {
        event.preventDefault();
        setOpenDetailHistory(false);
        setShowPopup(true);
      }
    }
  };

  const closePopUp = async () => {
    setShowPopup(false);
  };

  function onDismissDetailHistory() {
    setOpenDetailHistory(false);
  }

  const openSheetDetailHistory = async () => {
    setOpenDetailHistory(true);
  };

  function openOtherMenu() {
    setOtherOpened(true);
  }

  function closeOtherMenu() {
    setOtherOpened(false);
  }

  function openSupport() {
    setSupportOpened(true);
    setOpenDetailHistory(false);
  }

  function closeSupport() {
    setSupportOpened(false);
  }

  function openBroadcast() {
    setBroadcastOpened(true);
  }

  function closeBroadcast() {
    localStorage.setItem("broadcast", "1");
    setBroadcastOpened(false);
  }
  function funBcData() {
    getBroadcastActive("ACTIVE", "MOBILE").then((res) => {
      if (res.data.content.length > 0) {
        setDataBroadcast(res.data.content);
        if (JSON.parse(String(localStorage.getItem("broadcast"))) == "0") {
          openBroadcast();
        }
      }
    });
  }
  function sendMessage() {
    // console.log(supportMessage);
    let userStorage = JSON.parse(String(localStorage.getItem("user_redux")));
    let companyStorage = JSON.parse(String(localStorage.getItem("company")));
    let url = "";
    let anak = [];
    let phone = "6281326269992";
    let name = String(userStorage.name).split(" ").join("%20");
    if (userStorage.accounts[0].callerIdentities.length > 1) {
      for (
        let x = 0;
        x < userStorage.accounts[0].callerIdentities.length;
        x++
      ) {
        anak[x] = String(userStorage.accounts[0].callerIdentities[x].name)
          .split(" ")
          .join("%20");
        // console.log(userStorage.accounts[0].callerIdentities[x].name);
      }
      let d =
        "%20dan%20" + anak[userStorage.accounts[0].callerIdentities.length - 1];
      // d = String(d).substr(0, d.length - 3)
      anak[userStorage.accounts[0].callerIdentities.length - 1] = d;
      url = "text=Halo,%20saya%20" + name + "%20orang%20tua%20dari%20";
      url += anak;
    } else if (userStorage.accounts[0].callerIdentities.length == 1) {
      anak[0] = String(userStorage.accounts[0].callerIdentities[0].name)
        .split(" ")
        .join("%20");
      url = "text=Halo,%20saya%20" + name + "%20orang%20tua%20dari%20";
      url += anak;
    } else {
      url = "text=Halo,%20saya%20" + name;
    }
    let company = String(companyStorage.name).split(" ").join("%20");
    let pesan = String(supportMessage).split(" ").join("%20");
    url +=
      "%20dari%20" +
      company +
      "%20menemui%20kendala%20sebagai%20berikut:%0A%0A";
    url += pesan;
    let deviceType = localStorage.getItem("device");
    if (deviceType?.includes("android")) {
      // let x = `whatsapp://send?phone='${phone}'&`;
      let x = "https://wa.me/" + phone + "?";
      url = `${x}${url}`;
      let appVersion = localStorage.getItem("app_version")
        ? localStorage.getItem("app_version")
        : "PSP%20Mobile%20browser";
      appVersion = appVersion
        ? appVersion.replace("--", " ").replace(" ", "%20")
        : "PSP%20Mobile%20browser";
      url = `${url}"%0A%0ADikirim dari:%0A"${appVersion}`;
      openWhatsappAndroid(url);
      // let appVersion = localStorage.getItem("appVersion")
      //   ? localStorage.getItem("appVersion")
      //   : "PSP%20Mobile%20browser";
      // appVersion = appVersion
      //   ? appVersion.replace("--", " ").replace(" ", "%20")
      //   : "PSP%20Mobile%20browser";
      // url = `${url}"%0A%0ADikirim dari:%0A"${appVersion}`;
      // var element = document.createElement("a");
      // element.setAttribute("href", url);
      // element.click();
    } else {
      let x = "https://wa.me/" + phone + "?";
      url = `${x}${url}`;
      window.open(url, "_blank");
    }

    // console.log(url);
    setSupportOpened(false);
  }
  function openModal(item: any) {
    navigate("/info-detail/" + item._id, { replace: true });
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }
  function getImgCustom(url: string = "") {
    https: return (
      env +
      "main_a/web_view/custom_apps/icon/" +
      customApp?.company_id +
      "/" +
      url
    );
  }
  function getYtCode(str: String) {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = str.match(regExp);
    let x = "";
    if (match && match[2].length == 11) {
      x = match[2];
    } else {
      //error
    }
    return String(x)
      .replace("/", "")
      .replace("v=", "")
      .replace("?", "")
      .replace("#", "");
  }

  const login = async () => {
    var CryptoJS = require("crypto-js");
    var getCredential = localStorage.getItem("credential");

    var bytes = CryptoJS.AES.decrypt(getCredential, "credential");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    var data = decryptedData;

    dispatch(setLoading(true));
    API.login(data)
      .then((res) => {
        dispatch(setToken(res.headers.authorization.replaceAll("Bearer ", "")));
        API.credentialCheck()
          .then((resCredential) => {
            var auto = "1";
            var ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify(data),
              "credential"
            ).toString();
            localStorage.setItem("credential", ciphertext);
            localStorage.setItem("auto_login", auto);
            // var bytes = CryptoJS.AES.decrypt(ciphertext, 'password');
            dispatch(setUser(resCredential.data.user));
            api_balance.getBalance().then((balance) => {
              dispatch(setLoading(false));

              dispatch(setBalance(balance.data.balance));
              getInfo();

              navigate("/home");
            });
          })
          .catch((err: any) => {
            localStorage.setItem("0", "auto_login");

            // alert("428")
            console.log("1. going to login cause: " + err);
            navigate("/login", { replace: true });
          });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);

        toast.error(t("LOGIN.wrongLogin"));
      });
  };

  const getIconApp = async (customData: any = null) => {
    let result: any = {};

    let tempCustomApp: any = customApp?.app_menu.filter(
      (filter: any) => filter.menu_is_show == true
    );
    let tempCustomData: any = customData?.app_menu.filter(
      (filter: any) => filter.menu_is_show == true
    );

    console.log("customdata", customData);

    let bsiSvg = `<svg width="107" height="32" viewBox="0 0 107 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.4954 20.9996C13.8765 20.6196 13.2087 20.336 12.5128 20.1578C12.5265 20.1323 12.5424 20.1082 12.5603 20.0858C12.7117 20.0169 12.8571 19.9512 13.0144 19.8761C14.0409 19.4281 14.9043 18.6449 15.4778 17.6416C15.9621 16.6731 16.132 15.5639 15.9616 14.4838C15.7716 12.7938 15.0504 11.4575 13.6288 10.5875C12.1181 9.66426 10.4531 9.35443 8.7465 9.33565C5.94774 9.29184 3.14898 9.33565 0.350216 9.30749C0.0652946 9.29497 0 9.38885 0 9.67052C0 16.9103 0 24.149 0 31.3867C0 31.6997 0.0949739 31.7685 0.379896 31.7685C3.08368 31.7685 5.78747 31.7685 8.49126 31.7685C9.29776 31.7754 10.103 31.6988 10.8953 31.5401C14.1452 30.8515 16.3949 28.6014 16.5077 25.2277C16.564 23.4344 16.0061 21.9604 14.4954 20.9996ZM4.96832 15.9172C4.96832 15.1191 4.96832 14.318 4.96832 13.5199C4.96832 13.3791 4.92084 13.2069 5.15827 13.2069C6.34545 13.2382 7.55339 13.1444 8.74947 13.2602C10.6311 13.4385 11.204 14.5808 11.017 16.4899C10.8953 17.7417 10.1919 18.3989 8.97207 18.6117C8.05268 18.7175 7.12724 18.7531 6.20298 18.7181C5.88245 18.7181 5.56191 18.7181 5.24434 18.7181C5.02175 18.7181 4.94755 18.6462 4.96239 18.4052C4.97723 17.5946 4.96832 16.7559 4.96832 15.9172ZM11.5898 25.2715C11.4622 26.9865 10.3462 27.6625 9.08782 27.7752C7.82941 27.8878 6.50275 27.7939 5.21169 27.819C4.98613 27.819 4.96536 27.7063 4.96832 27.506C4.96832 26.6673 4.96832 25.8317 4.96832 25.0024C4.96832 24.173 4.96832 23.3531 4.96832 22.53C4.96832 22.3359 4.998 22.217 5.21763 22.2358C6.55617 22.2702 7.88877 22.1763 9.23325 22.2953C9.44566 22.3137 9.65617 22.3514 9.86245 22.4079C11.1832 22.771 11.7144 23.6191 11.5898 25.2715Z" fill="#00A29C"/>
    <path d="M29.8899 19.3408C28.6821 18.7363 27.427 18.2431 26.1385 17.8668C25.4515 17.6713 24.7976 17.364 24.2004 16.9561C23.8199 16.7156 23.5416 16.3302 23.4228 15.8795C23.3048 15.3623 23.3761 14.8172 23.6226 14.3531C23.8691 13.889 24.2726 13.54 24.7525 13.3758C25.4899 13.1254 26.2766 13.0823 27.0348 13.2507C27.9252 13.4322 28.7117 13.9173 29.5011 14.3679C30.2906 14.8186 30.9495 14.6496 31.4036 13.7796C31.7004 13.1912 31.9972 12.5934 32.294 11.9988C32.5908 11.4042 32.5908 11.4073 32.0862 11.0067C30.3055 9.62347 28.2695 9.0664 26.0821 9.05388C25.3107 9.03879 24.5406 9.12819 23.7908 9.3199C20.6923 10.1398 18.6979 12.7405 18.7424 15.9609C18.775 18.6367 19.8969 20.5614 22.2802 21.5941C23.2274 21.9851 24.1944 22.3205 25.1769 22.5987C26.0176 22.8115 26.8143 23.1849 27.5275 23.7003C28.6226 24.561 28.3496 26.9269 27.0852 27.4934C25.956 27.9865 24.6888 27.9954 23.5534 27.5184C22.7684 27.1695 22.0171 26.7419 21.3096 26.2416C20.5202 25.7471 19.7841 25.9443 19.2914 26.7579C19.0105 27.2211 18.7315 27.6906 18.4545 28.1663C17.8609 29.1364 17.8609 29.1552 18.781 29.8249C21.1094 31.586 23.9939 32.3285 26.83 31.8967C28.3382 31.7089 29.7465 31.0054 30.8397 29.8938C32.3979 28.2852 32.9796 26.2885 32.8549 24.0321C32.7332 21.8539 31.7004 20.3235 29.8899 19.3408Z" fill="#00A29C"/>
    <path d="M40.827 14.199C40.7521 12.8638 40.2361 11.5984 39.3686 10.6226C38.5012 9.64668 37.337 9.02195 36.0783 8.85681C35.7518 8.80361 35.6895 8.85681 35.6895 9.2042C35.6895 12.894 35.6895 16.5806 35.6895 20.2704C35.6895 23.9602 35.6895 27.7219 35.6895 31.4462C35.6895 31.7591 35.7577 31.8467 36.0575 31.8436C37.5414 31.8436 38.9987 31.8248 40.4708 31.8436C40.7973 31.8436 40.8774 31.756 40.8774 31.4117C40.8774 26.0007 40.8774 20.5865 40.8774 15.1723C40.8626 14.8468 40.8507 14.5214 40.827 14.199Z" fill="#00A29C"/>
    <path d="M49.1281 8.48743C47.3147 6.22787 47.0001 3.79306 48.22 1.17046C45.7061 2.3378 43.4327 1.95599 41.3492 0C41.5256 1.2956 41.3085 2.61684 40.7289 3.77428C40.1511 4.91525 39.2549 5.84163 38.1616 6.42817C40.7615 7.11355 42.3167 8.79726 42.9103 11.5638C44.3646 9.14152 46.4244 8.13692 49.1281 8.48743Z" fill="#F6AB3B"/>
    <path d="M59.2935 25.3842C58.5961 25.3842 57.8956 25.3842 57.1982 25.3842C56.9607 25.3842 56.9014 25.4561 56.9014 25.6971C56.9014 26.6579 56.9014 27.6218 56.9014 28.5826C56.9014 29.5434 56.9014 30.5292 56.9014 31.5025C56.9014 31.7716 56.9756 31.8374 57.2219 31.8155C57.9431 31.8155 58.6673 31.8155 59.3885 31.8155C59.6376 31.8116 59.8852 31.7727 60.1245 31.6997C61.5076 31.2991 62.2822 30.0691 62.2229 28.3823C62.2206 27.9816 62.1427 27.5853 61.9936 27.2167C61.8445 26.8481 61.6273 26.5145 61.3545 26.2354C61.0818 25.9563 60.7591 25.7372 60.4053 25.5911C60.0514 25.4449 59.6735 25.3746 59.2935 25.3842ZM61.2731 29.39C61.0268 30.4823 60.3234 31.0737 59.2312 31.105C58.8394 31.105 58.4477 31.105 58.044 31.105C57.8155 31.105 57.7472 31.0424 57.7472 30.7921C57.7472 30.0535 57.7472 29.3149 57.7472 28.5795C57.7472 27.844 57.7472 27.1524 57.7472 26.442C57.7472 26.1885 57.7917 26.0821 58.044 26.0977C58.4803 26.1227 58.9344 26.0977 59.3588 26.1165C59.7834 26.1224 60.1945 26.2749 60.529 26.5508C60.8636 26.8267 61.1031 27.2106 61.2108 27.6437C61.3778 28.2097 61.3993 28.8124 61.2731 29.39Z" fill="#00A29C"/>
    <path d="M52.3305 21.7663C52.4225 20.9088 52.0871 20.4143 51.1433 20.0513C51.8616 19.5818 52.0842 19.2939 52.1346 18.7994C52.2385 17.7917 51.6746 17.1063 50.6358 16.9718C49.879 16.8716 49.1192 16.9373 48.3624 16.9092C48.1131 16.9092 48.0418 16.9812 48.0418 17.244C48.0418 18.4959 48.0418 19.7665 48.0418 21.0277V23.087C48.0418 23.2247 48.0181 23.3686 48.2259 23.3655C49.045 23.3655 49.8642 23.3968 50.6774 23.3311C51.0852 23.3232 51.4768 23.1607 51.7804 22.8734C52.0839 22.586 52.2792 22.193 52.3305 21.7663ZM48.9293 17.6978C49.1222 17.5007 49.5228 17.6509 49.8553 17.6415C50.0325 17.6321 50.2102 17.6383 50.3865 17.6603C50.9801 17.7448 51.2621 18.0703 51.2769 18.6273C51.3063 18.8919 51.2355 19.1579 51.0799 19.3677C50.9243 19.5775 50.6964 19.7141 50.4459 19.7477C49.9771 19.8181 49.503 19.8401 49.0302 19.8134C48.8847 19.8134 48.8491 19.7383 48.8521 19.6038C48.8521 19.2908 48.8521 19.006 48.8521 18.643C48.8907 18.355 48.7156 17.9075 48.9293 17.6916V17.6978ZM49.0242 22.6645C48.8669 22.6645 48.858 22.5643 48.858 22.4423C48.858 22.1293 48.858 21.8445 48.858 21.5441C48.858 21.2437 48.858 21.0215 48.858 20.7586C48.858 20.4957 48.8966 20.4143 49.1548 20.4456C49.6631 20.4289 50.1719 20.4498 50.6774 20.5082C50.9101 20.532 51.1254 20.6485 51.2793 20.8341C51.4332 21.0197 51.5141 21.2602 51.5054 21.5065C51.5304 21.7643 51.4605 22.0222 51.3103 22.2272C51.1601 22.4322 50.9409 22.5686 50.6981 22.6082C50.1372 22.7239 49.5644 22.6363 49.0242 22.6582V22.6645Z" fill="#00A39D"/>
    <path d="M68.0401 26.107C67.5979 25.6827 67.046 25.4067 66.4545 25.3142C65.8631 25.2217 65.259 25.3168 64.719 25.5875C64.1994 25.8051 63.7548 26.1842 63.4442 26.6743C63.1336 27.1645 62.9716 27.7427 62.9798 28.3322C62.9798 29.5058 63.2024 30.3038 63.7871 30.9579C64.3723 31.5607 65.1563 31.9007 65.9744 31.9066C66.7924 31.9124 67.5808 31.5836 68.1737 30.9892C69.343 29.6998 69.2866 27.2493 68.0401 26.107ZM66.4819 31.0706C64.8971 31.3835 63.7544 30.285 63.8256 28.52C63.8731 27.3088 64.3628 26.4857 65.2503 26.2072C66.6185 25.7784 68.1262 26.4826 68.1262 28.6045C68.138 29.9377 67.5148 30.8734 66.4819 31.0706Z" fill="#00A29C"/>
    <path d="M55.4616 25.8567C55.4616 25.5437 55.4616 25.3684 55.0669 25.3653C54.6721 25.3622 54.6899 25.55 54.6929 25.8379C54.6929 27.2869 54.6929 28.7359 54.6929 30.2944C54.5504 30.1098 54.4703 30.0096 54.3961 29.9032C53.39 28.5262 52.3898 27.1492 51.3837 25.7753C51.3074 25.6624 51.2209 25.5576 51.1255 25.4623C50.9652 25.3121 50.7634 25.3747 50.5794 25.3935C50.3954 25.4122 50.4874 25.5719 50.4874 25.6689C50.4874 27.6311 50.4874 29.5934 50.4874 31.5556C50.4874 31.9061 50.6862 31.8154 50.8554 31.8185C51.0246 31.8216 51.2293 31.8967 51.2234 31.5494C51.2056 30.2255 51.2234 28.9017 51.2234 27.5748V26.9989C51.3481 26.9989 51.3718 27.0709 51.4104 27.1241C52.1553 28.1412 52.8943 29.1646 53.6423 30.1817C53.9954 30.6668 54.3546 31.1488 54.7048 31.637C54.7875 31.7369 54.8982 31.8065 55.0209 31.8357C55.1436 31.865 55.2719 31.8524 55.3874 31.7997C55.5625 31.7497 55.4646 31.5149 55.4675 31.3678C55.4586 29.5308 55.4497 27.6937 55.4616 25.8567Z" fill="#00A39D"/>
    <path d="M64.1726 23.3403C64.3833 23.2871 64.2765 23.0274 64.2765 22.8897C64.2765 21.0119 64.2765 19.1342 64.2765 17.2564C64.2765 16.9967 64.2379 16.8903 63.953 16.884C63.6057 16.884 63.4455 16.956 63.5048 17.3503C63.5197 17.5378 63.5197 17.7262 63.5048 17.9136V21.8194L63.2971 21.5534C62.2642 20.1346 61.2314 18.719 60.1985 17.3065C60.1239 17.1923 60.0373 17.0873 59.9403 16.9935C59.8526 16.9359 59.7539 16.8996 59.6512 16.8871C59.5486 16.8747 59.4446 16.8865 59.3467 16.9216C59.2458 16.9216 59.2814 17.0655 59.2814 17.1469C59.2814 19.1352 59.2814 21.1173 59.2814 23.0931C59.2814 23.1776 59.2458 23.309 59.3408 23.3216C59.537 23.36 59.7382 23.36 59.9344 23.3216C60.0887 23.2809 60.0116 23.0837 60.0116 22.9554C60.0116 21.4751 60.0116 19.9948 60.0116 18.4488C60.0976 18.5458 60.1481 18.5896 60.1896 18.646C60.9336 19.6641 61.6766 20.6833 62.4186 21.7036C62.7658 22.1793 63.122 22.6424 63.4573 23.1307C63.5362 23.2462 63.65 23.3299 63.78 23.368C63.9101 23.4061 64.0485 23.3963 64.1726 23.3403Z" fill="#01A39D"/>
    <path d="M75.0887 25.6346C75.0887 25.2215 74.7919 25.428 74.6257 25.3873C74.4595 25.3467 74.3289 25.4218 74.3289 25.6659C74.3289 26.7644 74.3289 27.8566 74.3289 28.9645V30.2914C74.2072 30.1381 74.133 30.0473 74.0618 29.9534L71.0108 25.766C70.9455 25.6784 70.8802 25.5876 70.809 25.5063C70.7289 25.4326 70.6307 25.3841 70.5258 25.3664C70.4208 25.3487 70.3133 25.3625 70.2154 25.4061C70.0462 25.4468 70.1293 25.6627 70.1293 25.8004C70.1293 27.6594 70.1293 29.5215 70.1293 31.3836C70.1293 31.6966 70.1293 31.8405 70.5122 31.8405C70.895 31.8405 70.8742 31.6841 70.8713 31.4024C70.8713 29.9315 70.8713 28.4606 70.8713 26.8802L74.1776 31.4149C74.2528 31.5268 74.3372 31.6316 74.4298 31.7279C74.599 31.8969 74.8127 31.8218 75.0086 31.8093C75.1184 31.8093 75.0887 31.6747 75.0887 31.5964C75.0887 29.6092 75.0709 27.6219 75.0887 25.6346Z" fill="#00A29C"/>
    <path d="M88.5336 23.3591C88.5807 23.3497 88.629 23.3497 88.6761 23.3591C88.9729 23.4092 89.0886 23.3185 89.0738 22.9648C89.0411 22.292 89.0738 21.616 89.0738 20.94C89.0738 20.8398 89.0292 20.7209 89.1925 20.6771C89.381 20.622 89.581 20.629 89.7656 20.6973C89.9503 20.7655 90.1107 20.8917 90.2253 21.0589C90.6943 21.7349 91.1632 22.414 91.6262 23.09C91.7182 23.2246 91.8072 23.356 91.9853 23.356H92.7777L90.8011 20.5394L90.9317 20.4956C91.8844 20.1294 92.3177 19.419 92.2049 18.43C92.11 17.5976 91.5015 17.0812 90.5162 16.9685C89.8543 16.8934 89.1895 16.9466 88.5277 16.9185C88.2902 16.9185 88.2309 16.9873 88.2309 17.2314C88.2309 19.1697 88.2309 21.1069 88.2309 23.0431C88.216 23.2965 88.2873 23.3998 88.5336 23.3591ZM89.0649 18.8181V17.8386C89.0649 17.7415 89.0471 17.6226 89.1954 17.6289C89.6685 17.5944 90.1438 17.6196 90.6112 17.704C90.8053 17.7397 90.9834 17.8407 91.1187 17.9918C91.254 18.143 91.3394 18.3362 91.362 18.5427C91.4112 18.7704 91.3935 19.0085 91.3113 19.2254C91.2291 19.4422 91.0864 19.6276 90.902 19.757C90.3678 20.1263 89.7594 20.0167 89.1747 20.0199C89.0292 20.0199 89.0678 19.879 89.0649 19.7883C89.0619 19.4691 89.0649 19.1436 89.0649 18.8181Z" fill="#00A29D"/>
    <path d="M106.991 20.3765C106.991 19.3406 106.991 18.3016 106.991 17.2657C106.991 17.0059 106.956 16.8526 106.671 16.9026C106.6 16.9136 106.528 16.9136 106.457 16.9026C106.208 16.862 106.134 16.9621 106.14 17.2156C106.157 17.9636 106.14 18.7147 106.14 19.4626C106.14 19.713 106.071 19.7756 105.843 19.7756C104.952 19.7756 104.062 19.7568 103.172 19.7756C102.875 19.7756 102.845 19.6723 102.851 19.4094C102.851 18.6615 102.851 17.9104 102.851 17.1624C102.851 16.9559 102.804 16.8494 102.596 16.8839C102.497 16.8992 102.397 16.8992 102.299 16.8839C102.041 16.8463 101.984 16.9684 101.987 17.2219C101.987 18.1826 101.987 19.1466 101.987 20.1073C101.987 21.0681 101.987 22.0571 101.987 23.0304C101.987 23.2745 102.05 23.3778 102.284 23.3433C102.366 23.3308 102.449 23.3308 102.531 23.3433C102.795 23.3903 102.827 23.2588 102.827 23.0085C102.812 22.248 102.827 21.4844 102.827 20.7239C102.827 20.4766 102.89 20.4109 103.124 20.4109C104.015 20.4109 104.905 20.4297 105.795 20.4109C106.092 20.4109 106.125 20.5111 106.119 20.7739C106.104 21.5376 106.119 22.2981 106.119 23.0617C106.119 23.2964 106.187 23.3746 106.401 23.3465C106.459 23.3373 106.518 23.3373 106.576 23.3465C106.873 23.3965 106.988 23.2964 106.977 22.949C106.971 22.1009 106.991 21.2371 106.991 20.3765Z" fill="#00A29D"/>
    <path d="M85.0612 17.1563C84.9247 16.7901 84.6635 16.9341 84.4409 16.909C84.2184 16.884 84.0907 16.909 84.0017 17.1563C83.7553 17.8698 83.4764 18.5708 83.2092 19.2781C82.7284 20.53 82.2516 21.7922 81.7787 23.0649C81.7461 23.1494 81.6125 23.259 81.7579 23.3466C81.921 23.4056 82.0983 23.404 82.2603 23.3419C82.4223 23.2798 82.5592 23.1611 82.6483 23.0055C82.7848 22.6487 82.9273 22.2888 83.043 21.9226C83.0513 21.8723 83.0689 21.8242 83.0949 21.7811C83.1209 21.7381 83.1548 21.7009 83.1946 21.6718C83.2344 21.6426 83.2792 21.6222 83.3266 21.6115C83.3739 21.6008 83.4228 21.6002 83.4704 21.6097C83.8117 21.6378 84.156 21.6097 84.5003 21.6097H84.6428C85.0464 21.6097 85.5331 21.4814 85.8299 21.6691C86.1267 21.8569 86.1742 22.4265 86.3315 22.8271C86.5452 23.3716 86.5363 23.3622 87.1062 23.3622C87.3644 23.3622 87.3733 23.2903 87.2842 23.0493C86.5393 21.0995 85.7914 19.131 85.0612 17.1563ZM83.4556 20.9399C83.4506 20.8984 83.4506 20.8563 83.4556 20.8148C83.8058 19.8508 84.159 18.8869 84.527 17.8886C84.901 18.9182 85.2631 19.9134 85.6341 20.9399H83.4556Z" fill="#00A29C"/>
    <path d="M98.9509 17.1781C98.8351 16.8652 98.6363 16.8996 98.4137 16.9058C98.1911 16.9121 97.9952 16.8432 97.8765 17.1687C97.4224 18.4393 96.9297 19.6974 96.4519 20.9586C96.1551 21.7442 95.8583 22.5234 95.5615 23.3184C96.3569 23.4404 96.3985 23.4154 96.6656 22.6924C96.7695 22.4139 96.8763 22.1354 96.9624 21.8537C96.9747 21.7821 97.012 21.718 97.0669 21.674C97.1219 21.6299 97.1905 21.6092 97.2592 21.6159C98.019 21.6159 98.7788 21.6159 99.5386 21.6159C99.6073 21.6085 99.6764 21.6266 99.7338 21.6672C99.7913 21.7078 99.8335 21.7682 99.8532 21.8381C99.963 22.1792 100.126 22.5047 100.215 22.852C100.225 22.9419 100.254 23.0285 100.299 23.1056C100.343 23.1828 100.404 23.2488 100.475 23.2991C100.546 23.3494 100.627 23.3827 100.712 23.3969C100.797 23.411 100.884 23.4056 100.966 23.3809C101.221 23.359 101.263 23.3184 101.165 23.068C100.42 21.0963 99.6751 19.1404 98.9509 17.1781ZM97.4996 20.968C97.3156 20.968 97.3126 20.8992 97.372 20.7427C97.7192 19.8038 98.0575 18.865 98.4107 17.8917L99.5267 20.968C98.8322 20.968 98.1614 20.968 97.4996 20.968Z" fill="#00A29C"/>
    <path d="M91.3024 25.6127C91.1689 25.2528 90.9166 25.4156 90.7088 25.3905C90.5011 25.3655 90.3586 25.3499 90.2637 25.619C89.9283 26.5579 89.5573 27.4967 89.2011 28.4356L87.916 31.8281C88.0217 31.8202 88.1279 31.8202 88.2336 31.8281C88.3166 31.8532 88.4038 31.859 88.4892 31.8449C88.5745 31.8309 88.6559 31.7973 88.7277 31.7467C88.7995 31.696 88.8599 31.6294 88.9048 31.5516C88.9496 31.4738 88.9778 31.3866 88.9874 31.2961C89.0765 30.9831 89.2249 30.6701 89.3228 30.3572C89.3281 30.3143 89.3417 30.273 89.3628 30.236C89.384 30.1989 89.4122 30.1669 89.4456 30.1419C89.4791 30.1169 89.5171 30.0995 89.5573 30.0908C89.5974 30.082 89.6389 30.0822 89.679 30.0912C90.415 30.1037 91.1501 30.1037 91.8841 30.0912C92.08 30.0912 92.1809 30.1412 92.2462 30.3447C92.3353 30.642 92.454 30.9299 92.5608 31.2209C92.8042 31.8969 92.9111 31.9564 93.6085 31.778C93.6116 31.7541 93.6116 31.7299 93.6085 31.706C92.8369 29.6687 92.0593 27.6438 91.3024 25.6127ZM89.673 29.4183L90.786 26.3607C91.1629 27.3997 91.525 28.3918 91.896 29.4183H89.673Z" fill="#00A29C"/>
    <path d="M57.1626 21.8759C57.2991 22.2765 57.4594 22.6677 57.5959 23.062C57.6523 23.2185 57.7265 23.375 57.9165 23.3562H58.5101C58.5293 23.2341 58.5039 23.1088 58.4388 23.0057C57.7087 21.0716 56.9697 19.1438 56.2485 17.2034C56.2238 17.0949 56.1594 17.001 56.0693 16.9424C55.9792 16.8837 55.8708 16.8651 55.7677 16.8905C55.5243 16.9124 55.2928 16.8216 55.1563 17.2034C54.5271 18.9341 53.8563 20.646 53.2034 22.3735C53.0847 22.6865 52.9719 22.9994 52.8413 23.3499C52.9402 23.3439 53.0393 23.3439 53.1381 23.3499C53.2194 23.3756 53.3049 23.3826 53.3889 23.3704C53.4729 23.3583 53.5535 23.3273 53.6252 23.2796C53.6969 23.2318 53.7581 23.1684 53.8046 23.0937C53.8512 23.0189 53.8819 22.9345 53.8949 22.8461C53.984 22.5112 54.1413 22.1983 54.2451 21.8696C54.2596 21.7916 54.3017 21.7223 54.3629 21.6758C54.4241 21.6292 54.4998 21.6091 54.5746 21.6193C55.3195 21.6193 56.0585 21.6193 56.8124 21.6193C56.8907 21.6079 56.9702 21.6279 57.035 21.6755C57.0999 21.723 57.1455 21.7946 57.1626 21.8759ZM56.5097 20.9683C55.8864 20.9683 55.2602 20.9683 54.5776 20.9683C54.9664 19.9105 55.3284 18.9184 55.6994 17.8982C56.0437 18.8371 56.3672 19.776 56.7145 20.671C56.8154 20.9214 56.756 20.9683 56.5097 20.9683Z" fill="#00A29C"/>
    <path d="M70.7108 23.3218C69.8204 22.2327 68.9894 21.1781 68.1287 20.1359C68.0011 19.9857 68.0011 19.945 68.1287 19.8042C68.4908 19.4099 68.8321 18.9936 69.1764 18.5805C69.6275 18.0454 70.0668 17.5039 70.5416 16.9469C70.2886 16.8676 70.0184 16.8741 69.7691 16.9657C69.5198 17.0572 69.3042 17.2291 69.1527 17.457C68.657 18.1267 68.0961 18.7401 67.5589 19.3723C67.4707 19.4927 67.3656 19.5983 67.2472 19.6853C66.9148 19.8824 66.6863 19.7416 66.6863 19.3504C66.6863 18.6525 66.6626 17.9515 66.6863 17.2536C66.7041 16.8123 66.437 16.9406 66.2203 16.9187C66.0037 16.8968 65.8375 16.9187 65.8434 17.2598C65.8642 18.6713 65.8434 20.0765 65.8434 21.4973V22.8086C65.8434 23.3876 65.8434 23.375 66.3895 23.375C66.6062 23.375 66.6863 23.3093 66.6715 23.0809C66.6715 22.3548 66.6715 21.6319 66.6715 20.9058C66.6715 20.7524 66.5884 20.524 66.7397 20.4614C66.8452 20.4183 66.959 20.4024 67.0715 20.4149C67.184 20.4275 67.2921 20.4681 67.3867 20.5334C67.4706 20.6041 67.5463 20.685 67.6123 20.7744C68.1881 21.4691 68.7995 22.1389 69.3248 22.8743C69.6988 23.3782 70.135 23.4157 70.7108 23.3218Z" fill="#00A29C"/>
    <path d="M80.0156 31.1082C79.235 31.1333 78.4515 31.1082 77.6679 31.1082C77.4572 31.1082 77.3711 31.055 77.386 30.8172C77.4038 30.2789 77.4008 29.7437 77.386 29.2054C77.386 28.9676 77.4542 28.8925 77.6679 28.9144C78.2853 28.9144 78.9026 28.9144 79.517 28.9144C79.8434 28.9144 79.7574 28.6953 79.7722 28.5138C79.787 28.3323 79.7722 28.1852 79.517 28.2008C78.9026 28.2196 78.2853 28.2008 77.6679 28.2008C77.4602 28.2008 77.3711 28.1601 77.386 27.916C77.4038 27.4028 77.4038 26.8895 77.386 26.3794C77.386 26.1447 77.4453 26.0852 77.662 26.0884C78.4574 26.0884 79.2528 26.0884 80.0363 26.0884C80.3005 26.0884 80.3331 25.9757 80.3124 25.7754C80.2916 25.5751 80.4044 25.3466 80.0482 25.3529C78.9679 25.3717 77.8905 25.3529 76.8102 25.3529C76.5817 25.3529 76.5342 25.4374 76.5342 25.6659C76.5342 26.6423 76.5342 27.6156 76.5342 28.592C76.5342 29.5685 76.5342 30.5167 76.5342 31.4775C76.5342 31.7373 76.5935 31.8186 76.8458 31.8155C77.9024 31.8155 78.956 31.8155 80.0126 31.8155C80.2738 31.8155 80.3272 31.7248 80.3094 31.4744C80.2916 31.224 80.3272 31.0988 80.0156 31.1082Z" fill="#00A39D"/>
    <path d="M75.273 19.7506C74.9406 19.6223 74.5993 19.5128 74.2787 19.3563C74.1014 19.2946 73.951 19.1677 73.8551 18.9987C73.7592 18.8298 73.7242 18.6301 73.7564 18.4362C73.782 18.2363 73.868 18.0505 74.0017 17.9062C74.1353 17.7619 74.3095 17.6668 74.4983 17.635C74.74 17.5714 74.9922 17.5665 75.2359 17.6207C75.4796 17.675 75.7085 17.7868 75.9051 17.948C76.0921 18.0857 76.2494 18.0888 76.3681 17.8478C76.4869 17.6068 76.5878 17.4848 76.3177 17.2939C75.8895 16.9977 75.3903 16.836 74.8782 16.8276C74.454 16.7868 74.0301 16.9078 73.6832 17.1685C73.3363 17.4291 73.0896 17.8123 72.9877 18.2484C72.8037 19.2092 73.2103 19.8727 74.2105 20.267C74.5969 20.3821 74.9757 20.5243 75.3442 20.6926C75.456 20.7436 75.5567 20.8182 75.64 20.9118C75.7233 21.0054 75.7876 21.1161 75.8288 21.237C75.8699 21.3578 75.8872 21.4863 75.8794 21.6144C75.8716 21.7426 75.8389 21.8677 75.7835 21.982C75.7026 22.1782 75.5708 22.3463 75.4033 22.467C75.2358 22.5877 75.0394 22.6561 74.8367 22.6642C74.569 22.6939 74.2984 22.6635 74.0426 22.575C73.7869 22.4866 73.5518 22.3421 73.3527 22.151C73.1717 21.9945 73.0114 22.0008 72.8838 22.2261C72.7562 22.4514 72.587 22.5547 72.8838 22.7769C73.3676 23.186 73.9702 23.407 74.5904 23.4028C75.6915 23.4028 76.4483 22.8113 76.6264 21.7817C76.8044 20.7521 76.4305 20.1981 75.273 19.7506Z" fill="#00A29C"/>
    <path d="M83.562 28.2163C83.1859 28.1038 82.8211 27.9529 82.4728 27.7657C82.3374 27.6884 82.2251 27.5729 82.1482 27.4322C82.0714 27.2915 82.0332 27.1311 82.0378 26.9688C82.0424 26.8065 82.0897 26.6488 82.1744 26.5132C82.2591 26.3776 82.3778 26.2695 82.5173 26.2009C82.8148 26.037 83.1582 25.9915 83.4849 26.0725C83.7615 26.1434 84.0225 26.2698 84.2536 26.445C84.402 26.5451 84.5504 26.5514 84.6453 26.3605C84.7403 26.1696 84.9154 26.0475 84.7047 25.8378C84.0102 25.1274 82.4995 25.1274 81.7753 25.8159C81.0512 26.5044 80.9651 28.1224 82.2532 28.6325C82.6954 28.8047 83.1436 28.9455 83.5858 29.1395C83.7547 29.1895 83.9038 29.2957 84.0108 29.4424C84.1178 29.589 84.1769 29.7682 84.1794 29.9532C84.189 30.1004 84.1709 30.248 84.126 30.3877C84.0811 30.5274 84.0104 30.6563 83.9179 30.7669C83.8254 30.8775 83.713 30.9677 83.5872 31.0322C83.4614 31.0966 83.3247 31.1341 83.1851 31.1425C82.9184 31.1754 82.6482 31.1481 82.3923 31.0623C82.1364 30.9765 81.9008 30.8342 81.7011 30.6449C81.5112 30.4821 81.3509 30.4696 81.1996 30.7075C81.0482 30.9453 80.9681 31.0861 81.2322 31.2927C81.7917 31.7234 82.4757 31.9358 83.1673 31.8936C83.5972 31.8986 84.0143 31.7394 84.3416 31.4455C84.6689 31.1516 84.8843 30.7427 84.9481 30.2944C85.1024 29.2209 84.7314 28.6576 83.562 28.2163Z" fill="#00A29C"/>
    <path d="M82.2978 16.9371C81.443 16.8433 81.4252 16.8495 81.0364 17.5631C80.5704 18.3987 80.1104 19.2374 79.6504 20.0667C79.1607 19.1873 78.6502 18.3079 78.1812 17.4066C78.1229 17.228 78.0048 17.078 77.8491 16.9847C77.6934 16.8914 77.5107 16.8611 77.3354 16.8996C77.2434 16.8996 77.1069 16.8839 77.0683 16.9371C76.9881 17.0435 77.1158 17.1343 77.1662 17.2251C77.8013 18.3329 78.4394 19.4439 79.0835 20.5487C79.1858 20.7153 79.2385 20.9104 79.2349 21.1089C79.2349 21.7598 79.2349 22.4108 79.2349 23.0586C79.2349 23.2839 79.2823 23.3716 79.5109 23.3528C79.6164 23.3403 79.7229 23.3403 79.8284 23.3528C80.0214 23.3747 80.0718 23.2808 80.0659 23.093C80.0659 22.7425 80.0955 22.3889 80.0659 22.0446C80.0138 21.6437 80.0396 21.2359 80.1417 20.8459C80.2437 20.4558 80.4199 20.0917 80.6595 19.7757C80.8561 19.4801 81.0364 19.1729 81.1996 18.8556L82.2978 16.9371Z" fill="#00A29C"/>
    <path d="M94.3182 16.8997C94.2475 16.9123 94.1753 16.9123 94.1045 16.8997C93.8404 16.8559 93.7632 16.9654 93.7662 17.2502C93.784 18.2079 93.7662 19.1687 93.7662 20.1294V22.752C93.7662 23.3779 93.7662 23.3779 94.3598 23.3779C94.5764 23.3779 94.6566 23.3216 94.6388 23.0869C94.6239 22.4891 94.6388 21.8883 94.6388 21.2905C94.6388 19.9448 94.6388 18.5959 94.6388 17.2502C94.6358 16.9748 94.5675 16.8653 94.3182 16.8997Z" fill="#01A39D"/>
    <path d="M86.5746 25.3842C86.5403 25.3907 86.5051 25.3907 86.4707 25.3842C86.2214 25.3404 86.1472 25.4499 86.1532 25.6972C86.1532 26.658 86.1532 27.6187 86.1532 28.5795C86.1532 29.5403 86.1532 30.548 86.1532 31.5338C86.1532 31.7435 86.2036 31.8468 86.4084 31.8092C86.5069 31.7956 86.6067 31.7956 86.7052 31.8092C86.9545 31.8499 87.0258 31.7498 87.002 31.4963C86.9842 30.7984 87.002 30.1005 87.002 29.4026C87.002 28.204 86.9872 27.0053 87.002 25.8098C87.0198 25.4343 86.9041 25.3216 86.5746 25.3842Z" fill="#01A39D"/>
    <path d="M48.4425 25.3777C48.1635 25.3777 48.021 25.3965 48.024 25.7658C48.0447 27.6028 48.024 29.443 48.024 31.2801C48.024 31.8309 48.024 31.8152 48.5552 31.8309C48.8224 31.8309 48.852 31.7307 48.852 31.4866C48.852 30.5227 48.852 29.5619 48.852 28.598C48.852 27.6341 48.8313 26.6984 48.852 25.7501C48.8847 25.3495 48.6888 25.3902 48.4425 25.3777Z" fill="#02A39D"/>
    </svg>`;

    if (customApp == undefined) {
      if (customData == null || tempCustomData == null) {
        return;
      }
      for (let index = 0; index < tempCustomData.length; index++) {
        if (
          customData.company_id == undefined ||
          tempCustomData[index].menu_icon_url == undefined
        ) {
          continue;
        }
        if (tempCustomData[index].menu_icon_url.includes("svg")) {
          await API.getIconApps(
            customData?.company_id,
            tempCustomData[index].menu_icon_url
          ).then((res) => {
            result[tempCustomData[index].id] = res.data;
          });
        } else {
          result[tempCustomData[index].id] = bsiSvg;
        }
      }
      dispatch(setIconApp(result));
      sethandleSvg(result);
    } else {
      for (let index = 0; index < tempCustomApp.length; index++) {
        if (tempCustomApp[index].menu_icon_url.includes("svg")) {
          await API.getIconApps(
            customApp?.company_id,
            tempCustomApp[index].menu_icon_url
          ).then((res) => {
            result[tempCustomApp[index].id] = res.data;
          });
        } else {
          result[tempCustomApp[index].id] = bsiSvg;
        }
      }
      dispatch(setIconApp(result));
      sethandleSvg(result);
    }
  };

  const getheaderImg = async (customData: any = null) => {
    console.log("getheaderImg", customApp, customData);
    let a: any = {};
    if (customApp == undefined) {
      if (customData != null) {
        API.getIconApps(customData?.company_id, customData?.app_icon_url).then(
          (res) => {
            a["app_icon_url"] = showSvg(res.data);
          }
        );

        API.getIconApps(
          customData?.company_id,
          customData?.app_mobile_background_header_url
        ).then((res) => {
          a["app_mobile_background_header_url"] = showSvg(res.data);
        });
      }
    } else {
      API.getIconApps(customApp?.company_id, customApp?.app_icon_url).then(
        (res) => {
          a["app_icon_url"] = showSvg(res.data);
        }
      );

      API.getIconApps(
        customApp?.company_id,
        customApp?.app_mobile_background_header_url
      ).then((res) => {
        a["app_mobile_background_header_url"] = showSvg(res.data);
      });
    }

    setHeaderImg(a);
  };

  const getInfo = async () => {
    var temp = [];
    if (dataTags == null) {
      temp = JSON.parse(String(localStorage.getItem("tags")));
      temp.push("info");
    } else {
      temp = _.concat(dataTags, ["info"]);
    }

    getInfoNews(0, temp, 10).then((res) => {
      setdataNews(res.data.content);
      navigate("/home");
    });
  };

  const getInitial = async (initial: any) => {
    api_company.getCompanyInitial(initial).then((res) => {
      setCompanyInitial(res.data.initial);
    });
  };
  useEffect(() => {
    let path2 = location.pathname.split("/")[2];
    let path3 = location.pathname.split("/")[3];
    let pat2Except = ["scan", "status", "booking"];
    if (path2 != undefined && !pat2Except.includes(path2)) {
      let app_version_kotlin = localStorage.getItem("app_version");
      if (app_version_kotlin?.toLowerCase().includes("katalis barokah")) {
        setAppName(app_version_kotlin?.split("--")[0]);
        default_menu.app_display_name = "Katalis Barokah";
        default_menu.app_accent_color = "#CE2027";
        default_menu.app_secondary_accent_color = "#CE2027";
      }
      if (app_version_kotlin?.toLowerCase().includes("edusmart amanah")) {
        setAppName(app_version_kotlin?.split("--")[0]);
        default_menu.app_display_name = "EduSmart Amanah";
        default_menu.app_accent_color = "#01703A";
        default_menu.app_secondary_accent_color = "#01703A";
      }
      dispatch(setToken(path2));
      localStorage.setItem("token_redux", path2);
      var bahasa = "";
      if (path3 != undefined) {
        var lang = path3;
        i18n.changeLanguage(lang);
        dispatch(setLanguage(lang));
        bahasa = path3.toUpperCase();
      }
      SetAccessFromApp(true);

      API.credentialCheck()
        .then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
          // console.log(resCredential.data.activeCompany, language.toUpperCase());
          localStorage.setItem("tags", JSON.stringify(resCredential.data.tags));
          api_balance
            .getBalance(path2)
            .then((res) => {
              dispatch(setBalance(res.data.balance));
              console.log("company");

              console.log("company", bahasa.toUpperCase());
              console.log("company", resCredential.data.activeCompany.id);
              console.log(
                "custom app baru " + resCredential.data.activeCompany.customApps
              );
              if (!resCredential.data.activeCompany.customApps) {
                default_menu.app_display_name =
                  resCredential.data.activeCompany.name;
                dispatch(setCustomApp(default_menu));
                console.log("setting to", default_menu);
                let total = 0;
                default_menu.app_menu.map((res: any) => {
                  if (res.menu_is_show) {
                    total += 1;
                  }
                });
                setTotalActiveMenu(total);

                // getIconApp(resCustom.data);
                getheaderImg(default_menu);
                console.log("asd " + iconApp);
                console.log(JSON.stringify(default_menu));
                getIconApp(default_menu);
                // console.log("asd2 " + Object.keys(iconApp)?.length);

                // if (!iconApp || Object.keys(iconApp)?.length < 1) {
                //   console.log("in");
                //   console.log("in1");

                //   getIconApp(default_menu);
                // } else {
                //   console.log("out");
                //   console.log("out2");

                //   sethandleSvg(iconApp);
                // }
                console.log("inout1");
                navigate("/home", { replace: true });
              } else {
                API.getCustomApps(
                  resCredential.data.activeCompany.id,
                  bahasa.toUpperCase()
                ).then((resCustom: any) => {
                  let tempResCustom = resCustom.data;
                  console.log(tempResCustom);
                  // if (!resCredential.data.activeCompany.customApps){
                  //   tempResCustom.app_display_name = "PSP Mobile";
                  //   tempResCustom.app_icon_url = "psp.svg";
                  //   tempResCustom.app_mobile_background_header_url = "header.svg";
                  //   tempResCustom.app_desktop_background_header_url = "header.svg";
                  //   tempResCustom.app_accent_color = "#0054E6";
                  //   tempResCustom.app_secondary_accent_color = "#0054E6";
                  //   tempResCustom = default_menu
                  // }
                  // const hasBsiAndNotActive = tempResCustom.app_menu.some(
                  //   ({ menu_name, menu_is_show }: { menu_name: string, menu_is_show: boolean }) =>
                  //     menu_name.toLowerCase().includes('bsi') && !menu_is_show
                  // );
                  // console.log(hasBsiAndNotActive)
                  // if (resCredential.data.activeCompany.banks.includes("BSI") && hasBsiAndNotActive){
                  // tempResCustom.app_menu.push({
                  //   id: "63dfc62c31bd560297c12397",
                  //   menu_name: "BSI Burekol",
                  //   menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
                  //   menu_icon_url: "bsi_burekol.svg",
                  //   menu_is_show: true,
                  //   menu_type: "URL"
                  // });
                  // }
                  console.log(tempResCustom);
                  dispatch(setCustomApp(tempResCustom));
                  let total = 0;
                  resCustom.data.app_menu.map((res: any) => {
                    if (res.menu_is_show) {
                      total += 1;
                    }
                  });
                  setTotalActiveMenu(total);

                  getIconApp(tempResCustom);
                  getheaderImg(resCustom.data);
                  console.log("rescustom", resCustom);
                  // console.log(Object.keys(iconApp)?.length);
                  // getIconApp();

                  // if (!iconApp || Object.keys(iconApp)?.length < 1) {
                  //   console.log("in");

                  // } else {
                  //   console.log("out");

                  //   sethandleSvg(iconApp);
                  // }
                  navigate("/home", { replace: true });
                });
              }
              getInfo();
            })
            .catch((err) => {
              dispatch(setLoading(false));

              if (auto === "1") {
                login();
              } else {
                // alert("694")
                console.log("2. going to login cause: " + err);
                navigate("/login", { replace: true });
              }
            });
        })
        .catch((err) => {
          dispatch(removeUser());
          dispatch(removeBalance());
          if (auto === "1") {
            login();
          } else {
            // alert("704")
            console.log("3. going to login cause: " + err);
            navigate("/login", { replace: true });
          }
        });
    } else {
      let app_version_kotlin = localStorage.getItem("app_version");
      if (app_version_kotlin?.toLowerCase().includes("katalis barokah")) {
        setAppName(app_version_kotlin?.split("--")[0]);
        default_menu.app_display_name = "Katalis Barokah";
        default_menu.app_accent_color = "#CE2027";
        default_menu.app_secondary_accent_color = "#CE2027";
      }
      if (app_version_kotlin?.toLowerCase().includes("edusmart amanah")) {
        setAppName(app_version_kotlin?.split("--")[0]);
        default_menu.app_display_name = "EduSmart Amanah";
        default_menu.app_accent_color = "#01703A";
        default_menu.app_secondary_accent_color = "#01703A";
      }
      if (user == undefined) {
        if (auto === "1") {
          login();
        } else {
          // alert("714")
          console.log("4. going to login cause: user undefined");
          navigate("/login", { replace: true });
        }
      } else {
        API.credentialCheck()
          .then((resCredential) => {
            dispatch(setUser(resCredential.data.user));
            api_balance
              .getBalance()
              .then((res) => {
                dispatch(setBalance(res.data.balance));
                getInitial(resCredential.data.activeCompany.companyCode);
                if (!resCredential.data.activeCompany.customApps) {
                  default_menu.app_display_name =
                    resCredential.data.activeCompany.name;
                  dispatch(setCustomApp(default_menu));
                  console.log("setting to", default_menu);
                  let total = 0;
                  default_menu.app_menu.map((res: any) => {
                    if (res.menu_is_show) {
                      total += 1;
                    }
                  });
                  setTotalActiveMenu(total);

                  getheaderImg(default_menu);
                  getIconApp(default_menu);
                  navigate("/home", { replace: true });
                } else {
                  API.getCustomApps(
                    resCredential.data.activeCompany.id,
                    language.toUpperCase()
                  ).then((resCustom: any) => {
                    let tempResCustom = resCustom.data;
                    // if (!resCredential.data.activeCompany.customApps){
                    //   tempResCustom.app_display_name = resCredential.data.activeCompany.name;
                    //   tempResCustom.app_icon_url = "psp.svg";
                    //   tempResCustom.app_mobile_background_header_url = "header.svg";
                    //   tempResCustom.app_desktop_background_header_url = "header.svg";
                    //   tempResCustom.app_accent_color = "#0054E6";
                    //   tempResCustom.app_secondary_accent_color = "#0054E6";
                    //   tempResCustom = default_menu
                    // }

                    // const hasBsiAndNotActive = tempResCustom.app_menu.some(
                    //   ({ menu_name, menu_is_show }: { menu_name: string, menu_is_show: boolean }) =>
                    //     menu_name.toLowerCase().includes('bsi') && !menu_is_show
                    // );

                    // if (resCredential.data.activeCompany.banks.includes("BSI") && hasBsiAndNotActive){
                    // tempResCustom.app_menu.push({
                    //   id: "63dfc62c31bd560297c12397",
                    //   menu_name: "BSI Burekol",
                    //   menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
                    //   menu_icon_url: "bsi_burekol.svg",
                    //   menu_is_show: true,
                    //   menu_type: "URL"
                    // });
                    // }
                    dispatch(setCustomApp(tempResCustom));
                    let total = 0;
                    resCustom.data.app_menu.map((res: any) => {
                      if (res.menu_is_show) {
                        total += 1;
                      }
                    });
                    setTotalActiveMenu(total);

                    // getIconApp(resCustom.data);
                    getheaderImg(tempResCustom);
                    console.log(iconApp);
                    // console.log(Object.keys(iconApp)?.length);

                    if (
                      (!iconApp || Object.keys(iconApp)?.length < 1) &&
                      Object.keys(iconApp)?.length != resCustom.data.app_menu
                    ) {
                      console.log("in");

                      getIconApp(resCustom.data);
                    } else {
                      console.log("out");

                      sethandleSvg(iconApp);
                    }
                    navigate("/home", { replace: true });
                  });
                }

                getInfo();
              })
              .catch((err) => {
                dispatch(setLoading(false));

                if (auto === "1") {
                  login();
                } else {
                  // alert("809")
                  console.log("5. going to login cause: " + err);
                  navigate("/login", { replace: true });
                }
              });
          })
          .catch((err) => {
            dispatch(setLoading(false));

            dispatch(removeUser());
            dispatch(removeBalance());
            if (auto === "1") {
              login();
            } else {
              // alert("822")
              console.log("6. going to login cause: " + err);
              navigate("/login", { replace: true });
            }
          });
      }
    }
    funBcData();
    setSkeletonIsActive(false);
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    if (location.pathname.split("/")[2] == undefined) {
      if (customApp != null) {
        getheaderImg();
      }

      if (!iconApp || Object.keys(iconApp)?.length < 1) {
        getIconApp();
      } else {
        console.log(iconApp);

        sethandleSvg(iconApp);
      }
    }

    // if (user == undefined) {
    //   dispatch(removeUser());
    //   dispatch(removeBalance());
    //   dispatch(removeToken());
    //   dispatch(removeLastService());
    //   dispatch(removeCustomApp());
    //   navigate("/login", { replace: true });
    // }
  }, []);

  useEffect(() => {
    if (iconApp && Object.keys(iconApp)?.length > 0) sethandleSvg(iconApp);
  }, [iconApp]);

  useEffect(() => {
    if (customApp && Object.keys(customApp)?.length > 0) getIconApp();
  }, [customApp]);
  // useEffect(() => {
  //   if (directUrl == true) {
  //     console.log("sdf");
  //     getheaderImg();
  //     getIconApp();
  //   }
  // }, [directUrl]);

  const handleRefresh = async () => {
    API.credentialCheck()
      .then((resCredential) => {
        let app_version_kotlin = localStorage.getItem("app_version");
        if (app_version_kotlin?.toLowerCase().includes("katalis barokah")) {
          setAppName(app_version_kotlin?.split("--")[0]);
          default_menu.app_display_name = "Katalis Barokah";
          default_menu.app_accent_color = "#CE2027";
          default_menu.app_secondary_accent_color = "#CE2027";
        }
        if (app_version_kotlin?.toLowerCase().includes("edusmart amanah")) {
          setAppName(app_version_kotlin?.split("--")[0]);
          default_menu.app_display_name = "EduSmart Amanah";
          default_menu.app_accent_color = "#01703A";
          default_menu.app_secondary_accent_color = "#01703A";
        }
        dispatch(setUser(resCredential.data.user));
        api_balance
          .getBalance()
          .then((res) => {
            dispatch(setBalance(res.data.balance));
            console.log(resCredential.data.activeCompany.customApps);
            if (!resCredential.data.activeCompany.customApps) {
              default_menu.app_display_name =
                resCredential.data.activeCompany.name;
              dispatch(setCustomApp(default_menu));
              console.log("setting to", default_menu);
              let total = 0;
              default_menu.app_menu.map((res: any) => {
                if (res.menu_is_show) {
                  total += 1;
                }
              });
              setTotalActiveMenu(total);

              // getIconApp(resCustom.data);
              getheaderImg(default_menu);
              console.log(iconApp);
              console.log(Object.keys(iconApp)?.length);

              if (!iconApp || Object.keys(iconApp)?.length < 1) {
                console.log("in");

                getIconApp(default_menu);
              } else {
                console.log("out");

                sethandleSvg(iconApp);
              }
            } else {
              API.getCustomApps(
                resCredential.data.activeCompany.id,
                language.toUpperCase()
              ).then((resCustom: any) => {
                let tempResCustom = resCustom.data;
                if (!resCredential.data.activeCompany.customApps) {
                  tempResCustom.app_display_name = "PSP Mobile";
                  tempResCustom.app_icon_url = "psp.svg";
                  tempResCustom.app_mobile_background_header_url = "header.svg";
                  tempResCustom.app_desktop_background_header_url =
                    "header.svg";
                  tempResCustom.app_accent_color = "#0054E6";
                  tempResCustom.app_secondary_accent_color = "#0054E6";
                  tempResCustom = default_menu;
                }
                const hasBsiAndNotActive = tempResCustom.app_menu.some(
                  ({
                    menu_name,
                    menu_is_show,
                  }: {
                    menu_name: string;
                    menu_is_show: boolean;
                  }) => menu_name.toLowerCase().includes("bsi") && !menu_is_show
                );
                if (
                  resCredential.data.activeCompany.banks.includes("BSI") &&
                  hasBsiAndNotActive
                ) {
                  // tempResCustom.app_menu.push({
                  //   id: "63dfc62c31bd560297c12397",
                  //   menu_name: "BSI Burekol",
                  //   menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
                  //   menu_icon_url: "bsi_burekol.svg",
                  //   menu_is_show: true,
                  //   menu_type: "URL"
                  // });
                }
                console.log(tempResCustom);
                dispatch(setCustomApp(tempResCustom));
                let total = 0;
                tempResCustom.map((res: any) => {
                  if (res.menu_is_show) {
                    total += 1;
                  }
                });
                setTotalActiveMenu(total);
                if (
                  (!iconApp || Object.keys(iconApp)?.length < 1) &&
                  Object.keys(iconApp)?.length != resCustom.data.app_menu
                ) {
                  console.log("in");

                  getIconApp(resCustom.data);
                } else {
                  console.log("out");

                  sethandleSvg(iconApp);
                }
              });
            }
            getInfo();
          })
          .catch((err) => {
            dispatch(removeUser());
            dispatch(removeBalance());
            if (auto === "1") {
              login();
            } else {
              // alert("964")
              console.log("7. going to login cause: " + err);
              navigate("/login", { replace: true });
            }
          });
      })
      .catch((err) => {
        dispatch(removeUser());
        dispatch(removeBalance());
        if (auto === "1") {
          login();
        } else {
          // alert("975")
          console.log("8. going to login cause: " + err);
          navigate("/login", { replace: true });
        }
      });
    if (Object.keys(iconApp).length < 0) {
      getIconApp();
    } else {
      sethandleSvg(iconApp);
    }
  };
  return (
    <>
      <div className="relative min-h-screen h-full w-screen bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div>
            <div
              style={{ backgroundColor: customApp?.app_accent_color }}
              className={
                otherOpened || supportOpened
                  ? `w-full h-60 relative overflow-hidden z-0`
                  : `w-full h-60 relative overflow-hidden`
              }
            >
              <div className="relative">
                {company?.id == "63c8094efbdfa807e1f9e6df" ? ( // jika company ibnu hafidz - 1043
                  <div className="flex-row z-100 pt-14 p-10 flex gap-2 w-full items-center justify-center">
                    <div className="flex flex-col justify-start gap-1 pt-1 items-start z-20">
                      <div className="flex w-full">
                        <h1 className="font-medium text-sm ml-[67px] text-white font-montserrat">
                          {t("HOME.title")}
                        </h1>
                      </div>
                      <LazyLoadImage
                        hidden={Object.keys(headerImg).length < 0}
                        src={headerImg["app_icon_url"]}
                        effect="blur"
                        className="h-14 min-w-[64px] items-center"
                      />
                    </div>
                    {/* <div className=" flex-col z-20 gap-0">
                  <span className="font-semibold text-base text-white font-montserrat">
                    {customApp?.app_display_name}
                  </span>
                </div> */}
                  </div>
                ) : (
                  <div className="z-100 p-10 pt-20 flex w-full gap-1 items-center justify-between">
                    <div className="flex flex-row justify-start gap-3 items-center z-20">
                      <LazyLoadImage
                        hidden={Object.keys(headerImg).length < 0}
                        src={
                          appName.toLowerCase().includes("katalis barokah")
                            ? katalisMerah
                            : appName.toLowerCase().includes("edusmart amanah")
                            ? katalisHijau
                            : headerImg["app_icon_url"]
                        }
                        effect="blur"
                        className="h-16 w-16 min-w-[64px]"
                      />
                    </div>
                    <div className=" flex-col z-20 gap-0  items-start">
                      <h1
                        className={`w-fit font-medium text-sm m-0 font-montserrat ${
                          isDarkColor(
                            customApp?.app_accent_color
                              ? customApp.app_accent_color
                              : "text-psp-primary"
                          )
                            ? "text-white"
                            : "text-black"
                        }`}
                      >
                        {t("HOME.title")}
                      </h1>
                      <span
                        className={`font-semibold text-base font-montserrat ${
                          isDarkColor(
                            customApp?.app_accent_color
                              ? customApp.app_accent_color
                              : "text-psp-primary"
                          )
                            ? "text-white"
                            : "text-black"
                        }`}
                      >
                        {customApp?.app_display_name}
                      </span>
                    </div>
                  </div>
                )}

                {/* <Parallax speed={-10} className="absolute right-0 -top-20 z-10">
              <LazyLoadImage effect="blur" src={handLeft} />
            </Parallax> */}
                <Parallax
                  speed={-5}
                  className="absolute top-5 z-0 min-w-full flex justify-center h-52"
                >
                  <LazyLoadImage
                    hidden={Object.keys(headerImg).length < 0}
                    effect="blur"
                    className="min-w-full h-full"
                    src={headerImg["app_mobile_background_header_url"]}
                  />
                </Parallax>
                {/* <Parallax speed={10} className="absolute left-0 top-30 z-10">
              <LazyLoadImage effect="blur" src={handRight} />
            </Parallax> */}
              </div>
            </div>

            <section
              id="main"
              className={
                otherOpened || supportOpened
                  ? "relative px-8 -mt-28 z-0"
                  : "relative px-8 -mt-28 z-50"
              }
            >
              <div className="relative mt-16 z-100 z-30 mb-4">
                <div className="rounded-2xl w-full bg-white flex flex-row p-3 justify-between shadow-lg shadow-psp-primary">
                  <div className="flex flex-col">
                    <h1 className="font-montserrat m-0 text-xs font-medium text-black text-start">
                      {t("HOME.balance")}
                    </h1>
                    <p className="font-montserrat m-0 text-xl font-bold text-black text-start">
                      {getBalance}
                    </p>

                    <button
                      onClick={() =>
                        navigate("/topup-history", {
                          state: { target: "home" },
                        })
                      }
                      className={`flex flex-row gap-2  mt-2 px-3  py-2 font-medium rounded-full ${
                        isDarkColor(
                          customApp?.app_secondary_accent_color
                            ? customApp.app_secondary_accent_color
                            : "text-psp-primary"
                        )
                          ? "text-white"
                          : "text-black"
                      }`}
                      style={{
                        fontSize: 9,
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                    >
                      <img
                        src={info}
                        width={12}
                        className={`${
                          isDarkColor(
                            customApp?.app_secondary_accent_color
                              ? customApp.app_secondary_accent_color
                              : "text-psp-primary"
                          )
                            ? ""
                            : "invert"
                        }`}
                      />
                      {t("HOME.history")}
                    </button>
                  </div>
                  <img src={dotBalance} alt="" />
                </div>
              </div>
              <div className="flex flex-row justify-between item-center">
                <h1 className="font-montserrat m-0 text-black text-sm font-bold">
                  {t("HOME.menu.title")}
                </h1>
                {totalActiveMenu > 8 ? (
                  <div
                    onClick={() => {
                      openSheetDetailHistory();
                    }}
                    className="flex flex-row gap-2 items-center"
                  >
                    <h1
                      style={{ color: customApp?.app_accent_color }}
                      className={` m-0 font-medium text-xs grow whitespace-nowrap`}
                    >
                      {t("HOME.viewAll")}
                    </h1>
                    <img src={arrowRight} className="flex-0" />
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              <div className="grid grid-cols-4 gap-x-4 gap-y-3  mt-3">
                {skeleton_menu.map((res) => (
                  <div
                    hidden={!skeletonIsActive}
                    className="flex no-underline w-full justify-center"
                  >
                    <div className="flex flex-col justify-center gap-2.5 w-fit">
                      <Skeleton
                        baseColor=""
                        style={{ borderRadius: 16, width: 56, height: 56 }}
                      />
                      <Skeleton
                        style={{ borderRadius: 4, width: 56, height: 12 }}
                      />
                    </div>
                  </div>
                ))}
                {customApp?.app_menu
                  .filter((filter: any) => filter.menu_is_show == true)
                  .slice(0, totalActiveMenu === 8 ? 8 : 7)
                  .map((custom: any, i: number) => {
                    let modifiedMenuPath = custom.menu_path;
                    if (custom.menu_type === "URL") {
                      const userToken = getToken;
                      modifiedMenuPath = custom.menu_path.replace(
                        "token",
                        userToken
                      );

                      if (modifiedMenuPath.includes("companyInitial")) {
                        modifiedMenuPath = modifiedMenuPath.replace(
                          "companyInitial",
                          getCompanyInital
                        );
                      }
                    }

                    return custom.menu_path != "/etc" ? (
                      custom.menu_type == "PAGE" ? (
                        <Link
                          hidden={skeletonIsActive}
                          to={custom.menu_path}
                          className="flex no-underline w-full justify-center"
                          onClick={(event) =>
                            handleMenuClick(modifiedMenuPath, event, custom)
                          }
                        >
                          <div className="flex flex-col items-center gap-2.5 w-fit">
                            <div className="flex flex-col justify-center items-center w-[56px] h-[56px] rounded-2xl   bg-white active:bg-black shadow-md shadow-gray-300">
                              <LazyLoadImage
                                // hidden={
                                //   !handleSVG || Object.keys(handleSVG)?.length < 0
                                // }
                                className="flex flex-col items-center p-2"
                                effect="blur"
                                src={showSvg(handleSVG[custom.id])}
                              />
                            </div>
                            <p
                              className="font-montserrat  m-0 font-medium text-center text-psp-nav"
                              style={{ fontSize: 10 }}
                            >
                              {custom.menu_name}
                            </p>
                          </div>
                        </Link>
                      ) : (
                        <button
                          hidden={skeletonIsActive}
                          onClick={() =>
                            localStorage.getItem("app_version")
                              ? androidOpenUrlInBrowser(modifiedMenuPath)
                              : localStorage.getItem("device")?.includes("ios")
                              ? openUrlInSafari(modifiedMenuPath)
                              : window.open(modifiedMenuPath, "_blank")
                          }
                          className="flex no-underline w-full justify-center"
                        >
                          <div className="flex flex-col items-center gap-2.5 w-fit">
                            <div className="flex flex-col justify-center items-center w-[56px] h-[56px] rounded-2xl   bg-white active:bg-black shadow-md shadow-gray-300">
                              <LazyLoadImage
                                // hidden={Object.keys(handleSVG).length < 0}
                                className="w-14 h-14 flex flex-col items-center p-2"
                                effect="blur"
                                src={showSvg(handleSVG[custom.id])}
                              />
                            </div>
                            <p
                              className="font-montserrat  m-0 font-medium text-center text-psp-nav"
                              style={{ fontSize: 10 }}
                            >
                              {custom.menu_name}
                            </p>
                          </div>
                        </button>
                      )
                    ) : (
                      <div className="flex no-underline w-full justify-center">
                        <div
                          className="flex flex-col items-center gap-2.5 w-fit"
                          onClick={() => openSupport()}
                        >
                          <div className="flex flex-col justify-center items-center w-[56px] h-[56px] rounded-2xl   bg-white active:bg-black shadow-md shadow-gray-300">
                            <LazyLoadImage
                              // hidden={Object.keys(handleSVG).length < 0}
                              className="w-14 h-14 flex flex-col items-center p-2"
                              effect="blur"
                              src={showSvg(handleSVG[custom.id])}
                            />
                          </div>
                          <p
                            className="font-montserrat  m-0 font-medium text-center text-psp-nav"
                            style={{ fontSize: 10 }}
                          >
                            {t("HOME.menu.support")}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                {totalActiveMenu > 8 ? (
                  <div className="flex no-underline w-full justify-center">
                    <div
                      onClick={() => openSheetDetailHistory()}
                      className="flex flex-col justify-center items-center gap-2.5 w-fit "
                    >
                      <div className="flex flex-col justify-center items-center w-[56px] h-[56px] rounded-2xl   bg-white active:bg-black shadow-md shadow-gray-300">
                        <LazyLoadImage
                          className="w-14 h-14 flex flex-col p-2"
                          effect="blur"
                          src={all}
                        />
                      </div>
                      <p
                        className="font-montserrat m-0 font-medium text-center text-psp-nav"
                        style={{ fontSize: 10 }}
                      >
                        {t("HOME.menu.others")}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </section>

            <section id="second-main" className="mt-3">
              <div className="flex flex-row justify-between item-center px-8">
                <h1 className="font-montserrat text-black m-0 text-sm font-bold">
                  {t("HOME.info")}
                </h1>
                <div
                  className="flex flex-row gap-2 items-center"
                  onClick={() => navigate("/info")}
                >
                  <h1
                    style={{ color: customApp?.app_accent_color }}
                    className={` m-0 font-medium text-xs grow whitespace-nowrap`}
                  >
                    {t("HOME.viewAll")}
                  </h1>
                  <img src={arrowRight} className="" />
                </div>
              </div>
              <div className="mb-8 mt-3 ml-8">
                <div className="flex overflow-x-auto max-h-50 flex-nowrap">
                  <div className="flex flex-nowrap gap-3 mr-2">
                    {dataNews.map((item: any) =>
                      item.isHeadline == true ? (
                        <div
                          className="mb-4 w-60 h-fit shadow-sm rounded-2xl relative bg-white"
                          onClick={() => openModal(item)}
                        >
                          <div className="flex h-32">
                            {(item.videoUrl ||
                              item.image ||
                              item.imageOpt.length > 0) && (
                              <div className="flex w-full">
                                {item.imageOpt.length < 1 && item.image && (
                                  <LazyLoadImage
                                    className="rounded-2xl h-32 w-60 object-cover"
                                    effect="blur"
                                    src={getImgContent(item.image)}
                                  />
                                )}
                                {item.imageOpt.length > 0 && item.image && (
                                  <LazyLoadImage
                                    className="rounded-2xl h-32 w-60 object-cover"
                                    effect="blur"
                                    src={getImgContent(item.image)}
                                  />
                                )}
                                {item.imageOpt.length > 0 && !item.image && (
                                  <LazyLoadImage
                                    className="rounded-2xl h-32 w-60 object-cover"
                                    effect="blur"
                                    src={getImgContent(item.imageOpt[0])}
                                  />
                                )}
                                {item.imageOpt.length == 0 &&
                                  !item.image &&
                                  item.videoUrl && (
                                    <LazyLoadImage
                                      className="rounded-2xl h-32 w-60 object-cover"
                                      effect="blur"
                                      src={`https://img.youtube.com/vi/${getYtCode(
                                        item.videoUrl
                                      )}/sddefault.jpg`}
                                    />
                                  )}
                              </div>
                            )}
                            {item.imageOpt.length == 0 &&
                              item.image == "" &&
                              item.videoUrl == "" && (
                                <LazyLoadImage
                                  className="rounded-2xl h-32 w-60 object-cover"
                                  effect="blur"
                                  src={banner}
                                />
                              )}
                          </div>
                          <div className="flex flex-col px-2 py-2 gap-1.5">
                            <h1 className="text-sm font-medium text-black text-left m-0">
                              {item.title}
                            </h1>
                            <p className="text-xs font-medium text-psp-gray text-left m-0">
                              {moment(item.updateTime).format("LL")}
                            </p>
                          </div>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Tabs tab={`${t("NAVBAR.home")}`}></Tabs>

      <BottomSheet
        className="relative"
        style={{ zIndex: 1000 }}
        open={openDetailHistory}
        onDismiss={onDismissDetailHistory}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={""}
      >
        <div className="px-4 py-2">
          <h1 className="font-poppins font-medium text-lg text-black my-2">
            {t("HOME.others")}
          </h1>

          <div className="grid grid-cols-4 gap-x-4 gap-y-3 mt-3">
            {customApp?.app_menu
              .filter((filter: any) => filter.menu_is_show == true)
              .slice(7, Number(customApp?.app_menu.length))
              .map((custom: any, i: number) => {
                let modifiedMenuPath = custom.menu_path;
                if (custom.menu_type === "URL") {
                  const userToken = getToken;
                  modifiedMenuPath = custom.menu_path.replace(
                    "token",
                    userToken
                  );

                  if (modifiedMenuPath.includes("companyInitial")) {
                    modifiedMenuPath = modifiedMenuPath.replace(
                      "companyInitial",
                      getCompanyInital
                    );
                  }
                }
                return custom.menu_path != "/support" ? (
                  custom.menu_type == "PAGE" ? (
                    <Link
                      to={handleUrl(custom.menu_path)}
                      className="no-underline flex flex-row justify-center"
                      onClick={(event) =>
                        handleMenuClick(modifiedMenuPath, event, custom)
                      }
                    >
                      <div className="flex flex-col items-center gap-2.5 w-fit">
                        <LazyLoadImage
                          hidden={Object.keys(handleSVG).length < 0}
                          className="w-14 h-14 flex flex-col rounded-2xl  bg-white active:bg-black shadow-md shadow-gray-300 items-center p-2"
                          effect="blur"
                          src={showSvg(handleSVG[custom.id])}
                        />
                        <p
                          className="font-montserrat m-0 font-medium text-center text-psp-nav"
                          style={{ fontSize: 10 }}
                        >
                          {custom.menu_name}
                        </p>
                      </div>
                    </Link>
                  ) : (
                    // <button
                    //   onClick={() =>
                    //     (window.location.href = `${custom.menu_path}`)
                    //   }
                    //   className="no-underline flex flex-row justify-center"
                    // >
                    <button
                      onClick={() =>
                        localStorage.getItem("app_version")
                          ? androidOpenUrlInBrowser(handleUrl(modifiedMenuPath))
                          : localStorage.getItem("device")?.includes("ios")
                          ? openUrlInSafari(handleUrl(modifiedMenuPath))
                          : window.open(handleUrl(modifiedMenuPath), "_blank")
                      }
                      className="text-sky-500 underline flex flex-row justify-center"
                    >
                      <div className="flex flex-col items-center gap-2.5 w-fit">
                        <LazyLoadImage
                          hidden={Object.keys(handleSVG).length < 0}
                          className="w-14 h-14 flex flex-col rounded-2xl  bg-white active:bg-black shadow-md shadow-gray-300 items-center p-2"
                          effect="blur"
                          src={showSvg(handleSVG[custom.id])}
                        />
                        <p
                          className="font-montserrat m-0 font-medium text-center text-psp-nav"
                          style={{ fontSize: 10 }}
                        >
                          {custom.menu_name}
                        </p>
                      </div>
                    </button>
                  )
                ) : (
                  <button
                    onClick={() => openSupport()}
                    className="text-sky-500 underline flex flex-row justify-center"
                  >
                    <div className="flex flex-col items-center gap-2.5 w-fit">
                      <LazyLoadImage
                        className="w-14 h-14 flex flex-col rounded-2xl  bg-white active:bg-black shadow-md shadow-gray-300 items-center p-2"
                        effect="blur"
                        src={showSvg(handleSVG[custom.id])}
                      />
                      <p
                        className="font-montserrat  m-0 font-medium text-center text-psp-nav"
                        style={{ fontSize: 10 }}
                      >
                        {t("HOME.menu.support")}
                      </p>
                    </div>
                  </button>
                );
              })}
          </div>
        </div>
      </BottomSheet>
      <Transition appear show={showPopup} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closePopUp}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("PROFILE.confirm")}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {t("HOME.undefinedMenu")}
                    </p>
                  </div>
                  <div className="mt-4 flex gap-2">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => closePopUp()}
                    >
                      {t("HOME.close")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={supportOpened} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeSupport}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div>{t("CUSTOMER.title")}</div>
                  </Dialog.Title>
                  <div className="mt-2">
                    <textarea
                      onChange={(e) => setSupportMessage(e.target.value)}
                      placeholder={`${t("CUSTOMER.message")}`}
                      className="w-full py-1 px-2 rounded-lg"
                    ></textarea>
                  </div>
                  <div className="mt-4 flex flex-row justify-evenly">
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`w-full h-10 mr-1 rounded-md ${
                        isDarkColor(
                          customApp?.app_secondary_accent_color
                            ? customApp.app_secondary_accent_color
                            : "text-psp-primary"
                        )
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={closeSupport}
                    >
                      {t("CUSTOMER.no")}
                    </button>
                    <button
                      type="button"
                      style={{ backgroundColor: customApp?.app_accent_color }}
                      className={`w-full h-10 ml-1 rounded-md ${
                        isDarkColor(
                          customApp?.app_accent_color
                            ? customApp.app_accent_color
                            : "text-psp-primary"
                        )
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={sendMessage}
                    >
                      {t("CUSTOMER.yes")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={broadcastOpened} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeBroadcast}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full bg-white rounded-2xl max-w-md transform text-left align-middle  transition-all">
                  {dataBroadcast.map((item: any, index: any) => {
                    if (index === 0) {
                      if (item.broadcastType === "IMAGE")
                        return (
                          <div key={index} className="w-auto h-full pb-2">
                            <Swiper
                              autoplay={true}
                              pagination={{ clickable: true, type: "fraction" }}
                              navigation={true}
                              centeredSlides={true}
                              slidesPerView={1}
                              modules={[Pagination, Navigation, Autoplay]}
                              className="flex justify-center items-center self-center relative "
                            >
                              {item.imagesFirebase.map((a: any, i: any) => {
                                return (
                                  <SwiperSlide
                                    key={i}
                                    className="justify-center items-center relative flex h-auto"
                                  >
                                    <img
                                      src={a}
                                      alt=""
                                      className="rounded-2xl h-auto w-auto object-contain relative"
                                    ></img>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                            </div>
                          </div>
                        );
                      if (item.broadcastType === "TEXT")
                        return (
                          <div key={index} className="w-full h-auto py-1">
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <div className="mt-4">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item.message,
                                  }}
                                ></span>
                              </div>
                            </div>
                          </div>
                        );
                    }
                  })}
                  <div className="absolute -bottom-6 left-0 right-0 flex flex-row">
                    <div className="flex m-auto justify-center bg-white">
                      <button
                        onClick={() => closeBroadcast()}
                        style={{
                          backgroundColor:
                            customApp?.app_secondary_accent_color,
                        }}
                        className="active:bg-rose-700 h-8 border-0 active:border-0 focus:border-0 flex flex-row px-3 z-50 text-white -mt-10 items-center gap-2 rounded-xl"
                      >
                        <img src={close} alt="" />
                        <span className="font-bold text-sm">
                          {t("LOGIN.close")}
                        </span>
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default HomeMobile;
